import common from '@page/common/js/common';
import { createApp, onMounted, ref, nextTick } from 'vue';
import Swiper, { Autoplay, Navigation } from 'swiper';

import useHeaderDiffer from '@composable/useHeaderDiffer';
import useGlobalLayout from '@global/composable/useGlobalLayout';
import useSetEnv from '@global/composable/useSetEnv';
import useAlert from '@global/composable/useAlert';
import useDialog from '@composable/useDialog';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import CartDialog from '@components/CartDialog.vue';
import ShareBtn from '@components/ShareBtn.vue';

import loadJsonSample from './index.json';

const { setEnv } = useSetEnv();
const { globalLayout } = useGlobalLayout();
const { alertDialog } = useAlert();
const { openDialog } = useDialog();
const { getArticleListAPI } = useAxiosAPI();

const app = createApp({
  components: {
    CartDialog,
    ShareBtn,
  },
  setup() {
    const isNotice = ref(true);
    const totalSection = ref(0);
    const popular = ref([]);
    const events = ref([]);

    const productList = ref({});
    const productListTop = ref({
      productList: [
        {
          brandName: '',
          products: [
            {
              name: '',
              customerMarketID: '',
              price: '',
              sell: '',
              img1x: '',
              img2x: '',
              imgURL: '',
              subItem: [],
            },
          ],
        },
      ],
    });

    const brandSwiperObject = ref({});
    const checkView = ref([]);

    /**
     * 主圖輪播
     */
    const bannerImages = ref([]);
    function randomBanner() {
      const arr = [];
      const bannerLength = productList.value.bannerImage?.length;
      while (arr.length < bannerLength) {
        const randomNum = Math.floor(Math.random() * bannerLength) + 1;
        if (arr.indexOf(randomNum) === -1) {
          arr.push(randomNum);
          bannerImages.value.push(productList.value.bannerImage[randomNum - 1]);
        }
      }
    }

    /**
     * 分類輪播
     */
    function swiperImage(swiperIndex, direction) {
      let subIndex = '';
      // eslint-disable-next-line no-unsafe-optional-chaining
      const mainLength = brandSwiperObject.value[`brandSwiper${swiperIndex}`]?.slides?.length - 2;

      if (direction <= 0) {
        subIndex = mainLength - 1;
      } else if (direction > mainLength) {
        subIndex = 0;
      } else {
        subIndex = direction - 1;
      }
      checkView.value[swiperIndex] = subIndex;
    }

    function createSwiper(container, prevBtn, nextBtn) {
      // eslint-disable-next-line no-underscore-dangle
      return new Swiper(container, {
        loop: true,
        slidesPerView: 1,
        modules: [Navigation],
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        on: {
          slideChange() {
            // 滑動或點擊都會觸發
            const swiperIndex = parseInt(container.replace('.brand-swiper', ''));
            const touchIndex = this.activeIndex;
            swiperImage(swiperIndex, touchIndex);
          },
        },
      });
    }

    function swiperView() {
      nextTick(() => {
        // eslint-disable-next-line no-new
        new Swiper('.mySwiper', {
          speed: 400,
          loop: true,
          modules: [Autoplay, Navigation],
          autoplay: {
            delay: 3000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });

        // eslint-disable-next-line no-new
        new Swiper('.event-swiper', {
          speed: 400,
          loop: true,
          spaceBetween: 8,
          modules: [Navigation],
          slidesPerView: 1.5,
          navigation: {
            prevEl: '.event-swiper-button-prev',
            nextEl: '.event-swiper-button-next',
          },
          breakpoints: {
            768: {
              spaceBetween: 24,
              slidesPerView: 3,
            },
          },
        });

        // eslint-disable-next-line no-new
        new Swiper('.live-swiper', {
          speed: 400,
          loop: true,
          spaceBetween: 8,
          modules: [Navigation],
          slidesPerView: 1.5,
          navigation: {
            prevEl: '.live-swiper-button-prev',
            nextEl: '.live-swiper-button-next',
          },
          breakpoints: {
            768: {
              spaceBetween: 24,
              slidesPerView: 3,
            },
          },
        });

        for (let i = 0; i < totalSection.value; i++) {
          const container = `.brand-swiper${i}`;
          const prevBtn = `.navigation-pre-${i}`;
          const nextBtn = `.navigation-next-${i}`;

          brandSwiperObject.value[`brandSwiper${i}`] = createSwiper(container, prevBtn, nextBtn);
          checkView.value[i] = 0;
        }

        // eslint-disable-next-line no-new
        new Swiper('.mag-swiper', {
          speed: 400,
          loop: true,
          spaceBetween: 8,
          modules: [Navigation],
          slidesPerView: 2.5,
          navigation: {
            prevEl: '.mag-swiper-button-prev',
            nextEl: '.mag-swiper-button-next',
          },
          breakpoints: {
            768: {
              spaceBetween: 24,
              slidesPerView: 2,
            },
          },
        });

        for (let i = 1; i <= $('.common-container').length; i++) {
          // eslint-disable-next-line no-new
          new Swiper(`.event-swiper-${i}`, {
            speed: 400,
            loop: true,
            spaceBetween: 8,
            modules: [Navigation],
            slidesPerView: 2.5,
            navigation: {
              prevEl: `.event-swiper-button-prev-${i}`,
              nextEl: `.event-swiper-button-next-${i}`,
            },
            breakpoints: {
              768: {
                spaceBetween: 24,
                slidesPerView: 3,
              },
            },
          });
        }
      });
    }

    function fireGAEvent(clickLink) {
      const { clickName, imgLink } = clickLink;

      window.localStorage.setItem(
        'promotion',
        JSON.stringify({
          clickName,
          imgLink,
        }),
      );
    }

    /**
     * 趨勢文章
     */
    const popularList = ref({});
    function getTrendList() {
      getArticleListAPI({
        params: {
          Category: 'ALL',
          Limit: 10,
          Page: 1,
          Content: 1,
        },
      })
        .then((res) => {
          if (res.data.Code === 200) {
            popularList.value = res.data.Response.Data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    /**
     * 手機 more
     */
    const { useMbMore } = useHeaderDiffer();

    onMounted(() => {
      totalSection.value = window.totalCategoryEvents;
      productList.value = loadJsonSample;
      productListTop.value = productList.value.productListTop;

      popular.value = productList.value.popular;
      events.value = productList.value.events;

      randomBanner();
      getTrendList();
      swiperView();
      useMbMore();
    });

    return {
      bannerImages,
      popular,
      events,
      popularList,
      productListTop,
      checkView,
      isNotice,
      openDialog,
      fireGAEvent,
    };
  },
});

app.mount('#home-content');

globalLayout({
  banner: {
    isOpen: false,
  },
  popupOpen: true,
  popupShowOnce: false,
});
